import { Component, OnInit, Inject, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { environment } from 'src/environments/environment';
import { TaskDTO } from 'src/app/interfaces/task';
import { UserDTO } from 'src/app/interfaces/user';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgIf } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { firstValueFrom } from 'rxjs';
import { TaskService } from 'src/app/services/task.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SettingsDTO } from 'src/app/interfaces/settings';
import { SettingsService } from 'src/app/services/settings.service';
import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { Image as TipTapImage } from '@tiptap/extension-image';
import { TableRow } from '@tiptap/extension-table-row';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';
import { TextAlign } from '@tiptap/extension-text-align';
import { TextStyle } from '@tiptap/extension-text-style';
import { CustomDiv } from 'src/app/extensions/customDiv';
import { CustomParagraph } from 'src/app/extensions/CustomParagraph';
import { CommonModule } from '@angular/common';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-task',
  imports: [MatSelectModule, MatOptionModule, FormsModule, MatDatepickerModule, MatIconModule, MatToolbarModule, NgIf, MatDatepickerModule,
    MatFormFieldModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatInputModule, MatButtonModule, CommonModule
  ],
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss'],
})
export class TaskComponent implements OnInit {
  @ViewChild('editorElement') set editorElement(element: ElementRef<HTMLDivElement>) {
    if (element && !this.editor) {
      // 1. Initialiseer de editor als deze nog niet bestaat
      this.initializeEditor(element.nativeElement);
    } else if (element && this.editor) {
      // 2. Als de editor al bestaat, update de content voor de nieuwe notitie
      this.editor.commands.setContent(this.task?.text || '');
    }
  }

  public editor!: Editor;

  task: TaskDTO = {
    id: -1, calendarId: -1, status: "Not started", priority: "Normal",
    calendarName: '',
    calendarColor: '',
    title: '',
    text: '',
    creationDate: undefined,
    dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    statusDate: undefined,
    sequence: 0,
    noteId: -1
  }

  settings: SettingsDTO = { id: -1, userId: -1, timeZone: "", outlookHours: 20, lookbackHours: 2, keepDoneVisible: 2, revisionsEnabled: false, showOnHold: false, taskNotificationsEnabled: true, taskNotificationTime: '9:00', meetingNotificationsEnabled: true, meetingNotificationLeadTime: 15, showWelcomePopup: true };
  isLoggedIn: boolean;
  user: UserDTO;
  role: string;
  isOk: boolean;
  envClass = 'prod';

  constructor(private errorhandling: ErrorhandlingService, private router: Router, private tokenStorageService: TokenStorageService, 
    public dialogRef: MatDialogRef<TaskComponent>, @Inject(MAT_DIALOG_DATA) data,
    private taskService: TaskService, private matDialog: MatDialog, private settingsService: SettingsService, private cdr: ChangeDetectorRef, 
    public functions: FunctionsService) {
    this.getSettings();
    if (data != null) {
      this.task = data;
      if (this.task.status == "") {
        this.task.status = "Not started";
      }
      if (this.task.priority == "") {
        this.task.priority = "Normal";
      }
    }

  }

  async getSettings() {
    this.settings = await firstValueFrom(this.settingsService.getSettings());
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
    } else {
      this.isOk = false;
    }
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

    ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.envClass = `env-${environment.name}`;

    this.isAuthorized();
  }

    initializeEditor(element: HTMLElement) {
    this.editor = new Editor({
      element: element,
      extensions: [
        StarterKit.configure({
          paragraph: false,
          heading: {
            HTMLAttributes: {
              style: null,
            },
          },
        }),
        TextStyle,
        CustomDiv,
        CustomParagraph,
        TipTapImage,
        TableRow,
        TableHeader,
        TableCell,
        TextAlign.configure({ types: ['heading', 'paragraph'] })
      ],
      content: this.task?.text || '',
      onUpdate: ({ editor }) => {
        if (this.task) {
          this.task.text = editor.getHTML();
        }
      },
    });
    this.cdr.detectChanges();
  }

  save() {
    this.dialogRef.close({ task: this.task });
  }

  followLink() {
    window.open(environment.baseURL + "/notes?id=" + this.task.noteId, "_blank");
  }

  removeLink() {
    this.task.noteId = null;
  }

  onDelete() {
    if (!this.task) return;

    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      width: '400px',
      panelClass: 'custom-dialog-container',
      data: { title: 'Delete task', message: `Are you sure you want to delete "${this.task.title}"?` }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result && this.task) {
        this.deleteTask();
      }
    });
  }

  async deleteTask() {
    const data = await firstValueFrom(this.taskService.deleteTask(this.task));
    this.dialogRef.close({ task: null });
  }

  public objectComparisonFunction = function (option, value): boolean {
    return option === value;
  }

    onHeadingChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    if (value === 'p') {
      this.editor.chain().focus().setParagraph().run();
    } else {
      const level = parseInt(value, 10) as 1 | 2 | 3;
      this.editor.chain().focus().toggleHeading({ level }).run();
    }
  }

  addImage() {
    const url = window.prompt('Afbeelding URL invoeren:');
    if (url) {
      this.editor.chain().focus().setImage({ src: url }).run();
    }
  }

}
